<!-- コード入力コンポーネント -->
<template>
  <div class="passcode__wrapper">
    <!-- 救済コードを入力してください -->
    <p class="passcode__wrapper--title">
      {{ $t("MyTicketTicketing.inputPasscode") }}
    </p>

    <!-- 打たれた番号の表示エリア -->
    <CodeInputDisplay :code="code" @parentMethod="sliceNumberFromCode" />

    <!-- 1~9,0のボタン群 -->
    <CodeInputButtons
      :code="code"
      :isFulfill="isFulfill"
      @parentMethod1="joinNumberToCode"
      @parentMethod2="executeGrandParentMethod"
    />
  </div>
</template>

<script>
import { watch, ref } from "vue";

export default {
  name: "TheCode0-9ButtonForm",
  props: {
    // 必要最低文字数a
    minDigit: {
      type: Number,
      required: true,
    },
  },
  setup(props, context) {
    const code = ref("");
    const isFulfill = ref(false);

    watch(code, (newVal) => {
      isFulfill.value = newVal.length >= props.minDigit ? true : false;
      console.log("newVal :>> ", newVal);
      context.emit("grandParentMethod1", newVal);
    });

    // 入力された文字列(code)をクリア
    const clearInputedCode = () => {
      code.value = "";
    };

    // 押された数字を文字列(code)に末尾に追加
    const joinNumberToCode = (number) => {
      code.value += number;
    };

    // 文字列(code)から末尾を削除
    const sliceNumberFromCode = () => {
      code.value = code.value.slice(0, -1);
    };

    // 子コンポーネントでOKを押されたら、親コンポーネントの持つメソッドを発火
    const executeGrandParentMethod = () => {
      context.emit("grandParentMethod2");
    };

    return {
      code,
      isFulfill,
      clearInputedCode,
      joinNumberToCode,
      sliceNumberFromCode,
      executeGrandParentMethod,
    };
  },
};
</script>

<style lang="scss" scoped>
.passcode__wrapper {
  width: 83vw;
  max-width: 272px;
  margin: auto;
  color: $white;
  top: var(--navigation-height);
  position: relative;
  .passcode__wrapper--title {
    text-align: center;
    padding-top: 42px;
    font-size: 14px;
  }
}
</style>
